import { Button, Typography } from '@mui/material'
import PublicRodadaList from 'entity/Rodada/components/PublicRodadaList';
import React from 'react'
import { useNavigate } from 'react-router-dom';

export default function BemVindo() {
    const navigate = useNavigate();
    return (
        <div >
            {/* <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1, padding: 5 }}>
                <Button onClick={() => navigate("/Login")}> Ir Para Login</Button>
            </div> */}
            <PublicRodadaList />
        </div>
    )
}
